module.exports = __webpack_public_path__ + "img/headPortrait.206528d1.png";